var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-card',{class:_vm.sizeClasses,on:{"toggleDrag":function($event){return _vm.$emit('toggleDrag')}}},[_c('b-tab',{attrs:{"title":"Activity & Rewards"}},[_c('eb-chat')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa7f6b52","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/chat/chat.vue
// module id = 4icS
// module chunks = 22